import React from 'react';
import { CtaButton } from './CtaButton';
import { PriceDisplay } from './PriceDisplay';
export function FinalRecap() {
  return <div className="max-w-3xl mx-auto px-5 md:px-6 py-10" data-id="element-186">
      <hr className="border-t-2 border-dashed border-border-light mb-10" data-id="element-187" />

      <h2 className="font-serif text-2xl md:text-3xl font-bold text-dark text-center mb-6" data-id="element-188">
        Una Vez Más, Esto Es TODO Lo Que Recibes:
      </h2>

      <div className="bg-gradient-to-br from-[#FFF8E1] to-highlight-bg border-[3px] border-accent rounded-2xl py-9 px-6 md:px-8 my-8" data-id="element-189">
        <div className="text-left font-sans text-base leading-loose mb-4" data-id="element-190">
          <p className="flex justify-between items-start py-2 border-b border-border-light" data-id="element-191">
            <span data-id="element-192">
              ✅ Acceso Inmediato a +1.000 Actividades paso a paso, mes a mes,
              con áreas de desarrollo detalladas...
            </span>
            <span className="text-green-dark font-bold ml-4 whitespace-nowrap" data-id="element-193">
              (Valor: <PriceDisplay amount={36} data-id="element-194" />)
            </span>
          </p>
          <p className="py-2 border-b border-border-light" data-id="element-195">
            ✅ Guías PDF Imprimibles — Sin pantallas, sin complicaciones
          </p>
          <p className="py-2 border-b border-border-light" data-id="element-196">
            ✅ Cobertura completa de 0 a 60 meses de vida
          </p>
          <p className="py-2 border-b border-border-light" data-id="element-197">
            ✅ 6 Áreas de Desarrollo cubiertas
          </p>
          <p className="py-2" data-id="element-198">✅ Garantía de Satisfacción 100% Sin Riesgo</p>
        </div>

        <p className="font-sans font-bold text-dark mt-6 mb-3" data-id="element-199">
          Más Estos Bonos Increíbles:
        </p>

        <div className="text-left font-sans text-base leading-loose mb-4" data-id="element-200">
          <p className="flex justify-between items-start py-2 border-b border-border-light" data-id="element-201">
            <span data-id="element-202">🧩 10 Juegos Montessori</span>
            <span className="text-green-dark font-bold ml-4 whitespace-nowrap" data-id="element-203">
              (Valor: <PriceDisplay amount={15} data-id="element-204" />)
            </span>
          </p>
          <p className="flex justify-between items-start py-2 border-b border-border-light" data-id="element-205">
            <span data-id="element-206">🎨 Tarjetas de Alto Contraste Imprimibles</span>
            <span className="text-green-dark font-bold ml-4 whitespace-nowrap" data-id="element-207">
              (Valor: <PriceDisplay amount={10} data-id="element-208" />)
            </span>
          </p>
          <p className="flex justify-between items-start py-2 border-b border-border-light" data-id="element-209">
            <span data-id="element-210">🥑 Alimentación BLW Segura</span>
            <span className="text-green-dark font-bold ml-4 whitespace-nowrap" data-id="element-211">
              (Valor: <PriceDisplay amount={12} data-id="element-212" />)
            </span>
          </p>
          <p className="flex justify-between items-start py-2" data-id="element-213">
            <span data-id="element-214">😤 10 Claves Para Gestionar Rabietas</span>
            <span className="text-green-dark font-bold ml-4 whitespace-nowrap" data-id="element-215">
              (Valor: <PriceDisplay amount={12} data-id="element-216" />)
            </span>
          </p>
        </div>

        <div className="font-sans text-lg font-bold border-t-2 border-accent pt-4 mt-4 text-dark text-center" data-id="element-217">
          Valor Total:{' '}
          <span className="text-primary text-2xl" data-id="element-218">
            <PriceDisplay amount={85} data-id="element-219" />
          </span>
        </div>

        <p className="font-sans text-lg mt-6 text-gray-600 text-center" data-id="element-220">
          Consíguelo Todo Por Un Pago Único De:
        </p>

        <div className="text-center my-4" data-id="element-221">
          <PriceDisplay amount={12.99} className="font-sans text-5xl md:text-6xl font-black text-primary" data-id="element-222" />
        </div>

        <div className="text-center my-6" data-id="element-223">
          <CtaButton size="large" subtitle="Acceso Inmediato a +1.000 Actividades >>" data-id="element-224">
            Añadir Al Carrito
          </CtaButton>
        </div>

        <p className="font-sans text-sm text-gray-500 text-center" data-id="element-225">
          Pago único. Sin cuotas mensuales ni costes ocultos. Me reservo el
          derecho de cerrar este descuento en cualquier momento sin previo aviso
          después del 25 de febrero de 2026.
        </p>
      </div>
    </div>;
}